import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthStore } from '../auth/auth.store';

export const authGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  authStore.hydrate();

  return authStore.isAuthenticated() ? true : router.createUrlTree(['/login']);
};
